<template>
	<div :class="type ==='navbar' ? 'box' : 'box-page'">
		<div class="d-flex justify-space-between align-center">
			<strong> {{ convertTimestamp(processName) }} {{ process.source }} </strong>
			<v-icon @click="downloadFile" :color="process.count === 100 ? 'success' : 'grey'" v-if="process.path">download</v-icon>
		</div>
		<v-progress-linear height="15" :value="process.count" color="primary">
			<template v-slot:default>
				<strong>
					<small>{{ process.count }}%</small>
				</strong>
			</template>
		</v-progress-linear>
		<p v-if="process.statusText">{{ process.statusText }}</p>
	</div>
</template>
<script>
export default {
	props: ["process", "type", "processName"],
	methods: {
		convertTimestamp(key) {
      if(!key){
        return;
      }
      const match = key.match(/(\d+)$/);
      if (match) {
        const timestamp = Number(match[1]);
         const date = new Date(timestamp);
        const humanDate = date.toLocaleString('fr-FR', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
        const base = key.replace(/\d+$/, '');
        return `${base} - ${humanDate}`;
      } else {
        console.log("Aucun timestamp trouvé dans la clé.");
        return key
      }
    },
		downloadFile() {
      if(this.process.count === 100 && this.process.file_name && this.process.path) { 
        this.$download(this.process.file_name, this.process.path)
      }
		}
	}
}
</script>
<style>
.box-page {
	display: block;
	width: 100%;
	padding: 15px 0;
	background-color: #fff;
	z-index: 9;
}
.box {
	display: block;
	width: 500px;
	padding: 15px;
	background-color: #fff;
	top: 50%;
	z-index: 9;
}

.box:nth-child(2) {
	top: calc(50% + 5px);
	z-index: 0;
	transform: scale(0.98);
	background-color: hsla(0, 0, 100%, 0.8)
}

.box:nth-child(3) {
	top: calc(50% + 10px);
	z-index: 0;
	transform: scale(0.96);
	background-color: hsla(0, 0, 100%, 0.6)
}

</style>
